import { ChangeEvent, FormEvent, useState } from 'react'

import ReportGmailerrorred from '@mui/icons-material/ReportGmailerrorred'
import { Alert, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Link from '@mui/material/Link'
import TextField from '@mui/material/TextField'

import { LoginForgotPassActiveForm, useCredentials } from './useLogin/useCredentials'

export const ForgotPasswordForm = () => {
  const { onActiveFormUpdate, forgotPassword, platform } = useCredentials()
  const [email, setEmail] = useState<string>('')
  const [showSuccessMessage, setShowSuccessMessage] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<Error>()

  const onEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const onSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!email) {
      return
    }

    if (showSuccessMessage) {
      setShowSuccessMessage(false)
    }

    setIsLoading(true)
    try {
      await forgotPassword(email, platform)
      setShowSuccessMessage(true)
    } catch (e) {
      setError(e as Error)
    } finally {
      setIsLoading(false)
    }
  }

  const goBackToLoginView = () => {
    onActiveFormUpdate(LoginForgotPassActiveForm.LOGIN)
  }

  return (
    <form onSubmit={onSubmit}>
      <Stack
        sx={{
          '& .MuiFormControl-root': {
            backgroundColor: '#f2f2f2'
          }
        }}
      >
        {!error && showSuccessMessage && (
          <Alert variant={'outlined'} color={'success'} sx={{ mb: 3 }}>
            An email will be sent in a moment. Please check your mailbox and follow the instruction
            in the email.
          </Alert>
        )}
        {error && (
          <Alert variant={'outlined'} color={'error'} sx={{ mb: 3 }} icon={<ReportGmailerrorred />}>
            {error.message}
          </Alert>
        )}
        <TextField
          required
          label={'Address email'}
          type={'email'}
          value={email}
          onChange={onEmailChange}
        />
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
          sx={{ mt: 4 }}
        >
          <Link href={'#'} variant="body2" underline={'hover'} onClick={goBackToLoginView}>
            Go back to Login page
          </Link>
          <Button
            variant={'contained'}
            color={'primary'}
            type={'submit'}
            disabled={isLoading || !email}
            startIcon={isLoading && <CircularProgress size={24} />}
          >
            Submit
          </Button>
        </Stack>
      </Stack>
    </form>
  )
}
